var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hg-topbar',[_c('p',{staticClass:"tw-m-0"},[_vm._v(" Benötigst du Hilfe? "),_c('a',{staticClass:"tw-text-teal-500",attrs:{"href":"tel:+4923018939742"}},[_vm._v("+49 2301 8939742")]),_vm._v(" - täglich von 8 bis 22 Uhr. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }